// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  encounterId: __t.u64().name("encounter_id"),
  heroId: __t.u64().name("hero_id"),
  destX: __t.i32().name("dest_x"),
  destY: __t.i32().name("dest_y"),
  owner: __t.identity(),
  setAt: __t.timestamp().name("set_at"),
});
